import React from 'react';
import PropTypes from 'prop-types';

import AbstractFunnel from "@components/abstract_funnel";
import withLoader from '@components/common/with_loader_decorator';
import withHistory from '@components/common/with_history_decorator'
import withPhoneCollector from '@components/common/with_phone_collector_decorator'
import Authenticator from '@components/common/authenticator'

import FunnelStatePersistance from '@services/funnel_state_persistance'

class CarUpholsteryFunnel extends AbstractFunnel {
    static childContextTypes = {
        locationStrategy: PropTypes.string
    };

    componentDidMount() {
        if(this.props.initializeStateAndHistory){
            this.props.initializeStateAndHistory({ componentName: 'CarUpholsteryFunnel', currentState: this.state });
        }
        FunnelStatePersistance.loadPersistedStateIfNeeded(this);
    }

    serviceType = () => {
        return 'car_upholstery_cleaning';
    };

    availabilityPathString = () => {
        return 'car_upholstery_availability_path';
    };


    companiesForDatePath = () => {
        return PathHelper('companies_for_date_car_upholstery_requests_path');
    };

    attributesPath = () => {
        return PathHelper('attributes_car_upholstery_requests_path');
    };

    extraServiceTypes = () => {
        return ['carpet_and_upholstery_cleaning']
    };
}


CarUpholsteryFunnel = withLoader(CarUpholsteryFunnel);
CarUpholsteryFunnel = withPhoneCollector(CarUpholsteryFunnel);
CarUpholsteryFunnel = withHistory(CarUpholsteryFunnel);

class AuthenticatingCarUpholsteryFunnel extends React.Component {
    render() {
        return (
            <Authenticator status={this.props.componentProps.authenticationStatus}
                           omniauthError={this.props.componentProps.omniauthError}
                           component={CarUpholsteryFunnel}
                           {...this.props} />
        );
    }
}

export default AuthenticatingCarUpholsteryFunnel;
